
import { Alert, Box, Grid } from '@mui/material';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, ListContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import styled from '@emotion/styled';
import { useState } from 'react';
import Map from "../components/MapBase";
import { safetyMonitoringImage } from '../assets/imgs';
import { monitoringPageName, realTimePageName, schedulePageName } from '../components/PageName';
import { useLocation, useNavigate } from 'react-router-dom';
import FormLabel from '../components/FormLabel';
import ObjectDetectionVideo from '../components/ObjectDetectionVideo';
import dayjs from 'dayjs';
import MediaMtxWebRtcVideo from '../components/MediaMtxWebRtcVideo';
import { useTranslation } from "react-i18next";

const MonitoringPageImage = styled.img`
    width: calc(60px + 51vw);
    margin: 28px;
`

const SafetyMonitoringPage = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const schedule = getLocation.state;
    const date = '2024-03-26' //test
    console.log("schedule, ", schedule)
    const handleButtonClick = () => {
        console.log("Acknowledge")
        alert("Acknowledge")
    }
    return (
        <MainContent type={schedulePageName}>
            <BackgroundStyle>

                <ListContainer>
                    <BigHeading>{t("Safety Monitoring Page")}</BigHeading>
                    <Box sx={{ marginTop: "10px" }}>
                        <ShortBlueButton onClick={handleButtonClick}>Acknowledge</ShortBlueButton>
                    </Box>
                    <FormLabel title={"Date"} value={dayjs(date).format("DD/MM/YYYY")}></FormLabel>
                    <FormLabel title={"Project No"} value={schedule?.projectNumber}></FormLabel>
                    <FormLabel title={"Project"} value={schedule?.projectName}></FormLabel>
                    <FormLabel title={"Location"} value={schedule?.location}></FormLabel>
                    <FormLabel title={"Worker"} value={schedule?.workers}></FormLabel>
                    {/* <MonitoringPageImage src={safetyMonitoringImage} alt="Construction site safety monitoring " /> */}
                    <div style={{ display: "flex", marginLeft: "28px", marginRight: "28px", }}>
                        <MediaMtxWebRtcVideo
                            mediaMtxWebRtcUrl="https://uat.castco.com.hk/web-rtc/mystream_view/"
                            style={{ maxWidth: '100%', width: '500px', }} />
                    </div>

                    <Box sx={{ margin: "28px" }}>
                        <BackButton onClick={() => navigate('/real-time', { state: { schedule: schedule } })} sx={{ marginLeft: '0px!important' }}>{t("Back")}</BackButton>
                    </Box>
                    {/* } */}
                </ListContainer>

            </BackgroundStyle>
        </MainContent >
    );
};

export default SafetyMonitoringPage;